// extracted by mini-css-extract-plugin
export default {"root":"ModalSpin_root__hvcTD"};